export const KATANA_MAINNET_REST_BASE_URL = "https://api-perps.katana.network" as const;
export const KATANA_SANDBOX_REST_BASE_URL = "https://api-perps-sandbox.katana.network" as const;

export const KATANA_MAINNET_WS_URL = "wss://websocket-perps.katana.network/v1" as const;
export const KATANA_SANDBOX_WS_URL = "wss://websocket-perps-sandbox.katana.network/v1" as const;

export const KATANA_API_KEY_HEADER = "kp-api-key" as const;
export const KATANA_HMAC_SIGNATURE_HEADER = "kp-hmac-signature" as const;

/**
 * Katana is single-collateral: every perp market settles in VBUSDC (virtual-balance USDC).
 * The `/v1/markets` response does not include a per-market settle field — this is a
 * protocol-level invariant. Source: https://api-docs-v1-perps.katana.network/#deposits-and-withdrawals
 */
export const KATANA_SETTLEMENT_TOKEN = "VBUSDC" as const;

export const KATANA_MAINNET_CHAIN_ID = 747474 as const;
export const KATANA_MAINNET_VERIFYING_CONTRACT = "0x62230CeA619F734cc215bB8074bbF07bE4Eb633e" as const;
export const KATANA_SANDBOX_CHAIN_ID = 737373 as const;
export const KATANA_SANDBOX_VERIFYING_CONTRACT = "0x92d3072dDe1aD3e9B7895500F504aA5e664E71d3" as const;

/**
 * The literal `message` string Katana's `DelegatedKeyAuthorization` typed
 * struct expects. Byte-for-byte fixed by the server — do not paraphrase.
 */
export const KATANA_DELEGATED_KEY_AUTHORIZATION_MESSAGE =
  "Sign this free message to prove you control this wallet" as const;

export const KATANA_DELEGATED_KEY_AUTHORIZATION_TYPES = {
  DelegatedKeyAuthorization: [
    { name: "nonce", type: "uint128" },
    { name: "delegatedPublicKey", type: "address" },
    { name: "message", type: "string" },
  ],
} as const;

export interface KatanaEip712Domain {
  name: "KatanaPerps";
  version: string;
  chainId: number;
  verifyingContract: `0x${string}`;
}
